// removed by extract-text-webpack-plugin
module.exports = {"Container":"forgotPassword__Container__2cN9K","ForgotPasswordContainer":"forgotPassword__ForgotPasswordContainer__2Hrb0","Title":"forgotPassword__Title__2w5l3","ErrorMsg":"forgotPassword__ErrorMsg__3nVpz","Error":"forgotPassword__Error__2WpRI","Form":"forgotPassword__Form__2tt1z","Submit":"forgotPassword__Submit__2vEYA","Loading":"forgotPassword__Loading__34HzL","SuccessMsg":"forgotPassword__SuccessMsg__3oHC4","Success":"forgotPassword__Success__29zoQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/ForgotPassword/forgotPassword.css
// module id = 1257
// module chunks = 2